export const workflows = [
  {
    id: 'sales',
    name: 'Sales Process',
    reference: {
      steps: [
        { id: '1', name: 'Lead Generation', x: 0, y: 0 },
        { id: '2', name: 'Qualification', x: 200, y: 0 },
        { id: '3', name: 'Discovery', x: 400, y: 0 },
        { id: '4', name: 'Proposal', x: 600, y: 0 },
        { id: '5', name: 'Negotiation', x: 800, y: 0 },
        { id: '6', name: 'Closed Won', x: 1000, y: 0 },
      ],
      connections: [
        { from: '1', to: '2' },
        { from: '2', to: '3' },
        { from: '3', to: '4' },
        { from: '4', to: '5' },
        { from: '5', to: '6' },
      ]
    },
    detected: [
      {
        id: 'detected-1',
        name: 'Sales Process - Variant A',
        frequency: 342,
        percentage: 45.2,
        source: 'Salesforce + Email',
        confidence: 0.94,
        steps: [
          { id: '1', name: 'Lead Generation', x: 0, y: 0 },
          { id: '2', name: 'Qualification', x: 200, y: 0 },
          { id: '3a', name: 'Initial Contact', x: 400, y: -50 },
          { id: '3b', name: 'Discovery', x: 400, y: 50 },
          { id: '4', name: 'Proposal', x: 600, y: 0 },
          { id: '5', name: 'Negotiation', x: 800, y: 0 },
          { id: '6', name: 'Closed Won', x: 1000, y: 0 },
        ],
        connections: [
          { from: '1', to: '2' },
          { from: '2', to: '3a' },
          { from: '2', to: '3b' },
          { from: '3a', to: '4' },
          { from: '3b', to: '4' },
          { from: '4', to: '5' },
          { from: '5', to: '6' },
        ],
        differences: [
          'Additional "Initial Contact" step before Discovery',
          'Parallel paths from Qualification to Proposal'
        ],
        detectedFrom: [
          { system: 'Salesforce', events: 156, lastSeen: '2024-01-15' },
          { system: 'Email', events: 186, lastSeen: '2024-01-15' }
        ]
      },
      {
        id: 'detected-2',
        name: 'Sales Process - Variant B',
        frequency: 198,
        percentage: 26.1,
        source: 'Salesforce + SAP',
        confidence: 0.87,
        steps: [
          { id: '1', name: 'Lead Generation', x: 0, y: 0 },
          { id: '2', name: 'Qualification', x: 200, y: 0 },
          { id: '3', name: 'Discovery', x: 400, y: 0 },
          { id: '4', name: 'Proposal', x: 600, y: 0 },
          { id: '5a', name: 'Internal Review', x: 800, y: -50 },
          { id: '5b', name: 'Negotiation', x: 800, y: 50 },
          { id: '6', name: 'Closed Won', x: 1000, y: 0 },
        ],
        connections: [
          { from: '1', to: '2' },
          { from: '2', to: '3' },
          { from: '3', to: '4' },
          { from: '4', to: '5a' },
          { from: '4', to: '5b' },
          { from: '5a', to: '6' },
          { from: '5b', to: '6' },
        ],
        differences: [
          'Internal Review step added before closing',
          'Parallel negotiation paths'
        ],
        detectedFrom: [
          { system: 'Salesforce', events: 98, lastSeen: '2024-01-14' },
          { system: 'SAP', events: 100, lastSeen: '2024-01-14' }
        ]
      },
      {
        id: 'detected-3',
        name: 'Sales Process - Variant C',
        frequency: 217,
        percentage: 28.7,
        source: 'Email + Asana',
        confidence: 0.91,
        steps: [
          { id: '1', name: 'Lead Generation', x: 0, y: 0 },
          { id: '2', name: 'Qualification', x: 200, y: 0 },
          { id: '3', name: 'Discovery', x: 400, y: 0 },
          { id: '4', name: 'Proposal', x: 600, y: 0 },
          { id: '5', name: 'Negotiation', x: 800, y: 0 },
          { id: '6', name: 'Closed Won', x: 1000, y: 0 },
        ],
        connections: [
          { from: '1', to: '2' },
          { from: '2', to: '3' },
          { from: '3', to: '4' },
          { from: '4', to: '5' },
          { from: '5', to: '6' },
        ],
        differences: [
          'No structural differences, but different timing patterns',
          'Average cycle time 15% longer than reference'
        ],
        detectedFrom: [
          { system: 'Email', events: 142, lastSeen: '2024-01-15' },
          { system: 'Asana', events: 75, lastSeen: '2024-01-15' }
        ]
      }
    ]
  },
  {
    id: 'procurement',
    name: 'Procurement Process',
    reference: {
      steps: [
        { id: '1', name: 'Requisition', x: 0, y: 0 },
        { id: '2', name: 'Approval', x: 200, y: 0 },
        { id: '3', name: 'Vendor Selection', x: 400, y: 0 },
        { id: '4', name: 'PO Creation', x: 600, y: 0 },
        { id: '5', name: 'Receipt', x: 800, y: 0 },
        { id: '6', name: 'Invoice', x: 1000, y: 0 },
      ],
      connections: [
        { from: '1', to: '2' },
        { from: '2', to: '3' },
        { from: '3', to: '4' },
        { from: '4', to: '5' },
        { from: '5', to: '6' },
      ]
    },
    detected: [
      {
        id: 'detected-4',
        name: 'Procurement Process - Variant A',
        frequency: 523,
        percentage: 38.5,
        source: 'SAP + Email',
        confidence: 0.96,
        steps: [
          { id: '1', name: 'Requisition', x: 0, y: 0 },
          { id: '2a', name: 'Manager Approval', x: 200, y: -50 },
          { id: '2b', name: 'Finance Approval', x: 200, y: 50 },
          { id: '3', name: 'Vendor Selection', x: 400, y: 0 },
          { id: '4', name: 'PO Creation', x: 600, y: 0 },
          { id: '5', name: 'Receipt', x: 800, y: 0 },
          { id: '6', name: 'Invoice', x: 1000, y: 0 },
        ],
        connections: [
          { from: '1', to: '2a' },
          { from: '1', to: '2b' },
          { from: '2a', to: '3' },
          { from: '2b', to: '3' },
          { from: '3', to: '4' },
          { from: '4', to: '5' },
          { from: '5', to: '6' },
        ],
        differences: [
          'Parallel approval paths (Manager and Finance)',
          'Both approvals required before Vendor Selection'
        ],
        detectedFrom: [
          { system: 'SAP', events: 312, lastSeen: '2024-01-15' },
          { system: 'Email', events: 211, lastSeen: '2024-01-15' }
        ]
      }
    ]
  },
  {
    id: 'hiring',
    name: 'Hiring Process',
    reference: {
      steps: [
        { id: '1', name: 'Job Posting', x: 0, y: 0 },
        { id: '2', name: 'Resume Review', x: 200, y: 0 },
        { id: '3', name: 'Phone Screen', x: 400, y: 0 },
        { id: '4', name: 'Interview', x: 600, y: 0 },
        { id: '5', name: 'Offer', x: 800, y: 0 },
        { id: '6', name: 'Onboarding', x: 1000, y: 0 },
      ],
      connections: [
        { from: '1', to: '2' },
        { from: '2', to: '3' },
        { from: '3', to: '4' },
        { from: '4', to: '5' },
        { from: '5', to: '6' },
      ]
    },
    detected: [
      {
        id: 'detected-5',
        name: 'Hiring Process - Variant A',
        frequency: 89,
        percentage: 52.3,
        source: 'Asana + Email',
        confidence: 0.89,
        steps: [
          { id: '1', name: 'Job Posting', x: 0, y: 0 },
          { id: '2', name: 'Resume Review', x: 200, y: 0 },
          { id: '3', name: 'Phone Screen', x: 400, y: 0 },
          { id: '4a', name: 'Technical Interview', x: 600, y: -50 },
          { id: '4b', name: 'Cultural Fit', x: 600, y: 50 },
          { id: '5', name: 'Offer', x: 800, y: 0 },
          { id: '6', name: 'Onboarding', x: 1000, y: 0 },
        ],
        connections: [
          { from: '1', to: '2' },
          { from: '2', to: '3' },
          { from: '3', to: '4a' },
          { from: '3', to: '4b' },
          { from: '4a', to: '5' },
          { from: '4b', to: '5' },
          { from: '5', to: '6' },
        ],
        differences: [
          'Split interview into Technical and Cultural Fit',
          'Both interview types required before Offer'
        ],
        detectedFrom: [
          { system: 'Asana', events: 67, lastSeen: '2024-01-15' },
          { system: 'Email', events: 22, lastSeen: '2024-01-15' }
        ]
      }
    ]
  }
];

